var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMoon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.84473 21.492C6.63186 21.7535 7.46243 21.9199 8.32279 21.9774C8.54664 21.9924 8.77251 22 9.00016 22C14.523 22 19.0002 17.5228 19.0002 12C19.0002 6.47715 14.523 2 9.00016 2C8.77251 2 8.54664 2.00761 8.32279 2.02258C7.46243 2.08013 6.63186 2.24649 5.84473 2.50803C6.46831 2.99113 7.04301 3.53432 7.56012 4.12891C9.39255 6.2359 10.502 8.98839 10.502 12C10.502 15.0116 9.39255 17.7641 7.56012 19.8711C7.043 20.4657 6.46832 21.0089 5.84473 21.492ZM10.0384 19.9332C13.9662 19.4242 17.0002 16.0664 17.0002 12C17.0002 7.93358 13.9662 4.57579 10.0384 4.06676C11.5913 6.32103 12.502 9.05437 12.502 12C12.502 14.9456 11.5913 17.679 10.0384 19.9332Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMoon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/moon.d38343dd70469e5f0b06f27aa5650624.svg";